import React from 'react'
import TeamMembers from './TeamMembers'
import LeaveTeam from './LeaveTeam'


const InGroupComp = (props) => {
    return (
        <>
            <div
                className='mt-5'
                style={{
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: "10px",
                    margin: "20px 10px",
                }}
            >
                <h3 className="m-0" >Team Name:</h3>
                <h2 className="m-0" >{props.teamName}</h2>
            </div>

            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: "10px",
                    margin: "20px 10px",
                }}
            >
                <h3 className="m-0" >Facilitator:</h3>
                <h2 className="m-0" >{props.facilitatorName ?? "Not assigned yet"}</h2>
            </div>
            <TeamMembers teamMembers={props.teamMembers} />
            <LeaveTeam
                setTeamMembers={props.setTeamMembers}
                setInGroup={props.setInGroup}
                setTeamName={props.setTeamName}
            />
        </>
    )
}

export default InGroupComp